/*
 * An object containing properties for button events
 */
var ButtonEvent = /** @class */ (function () {
    function ButtonEvent() {
    }
    return ButtonEvent;
}());
export { ButtonEvent };
//# sourceMappingURL=button-event.js.map